"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowTool = void 0;
const fabric_with_gestures_1 = require("fabric-with-gestures");
const arrowToolOptions_1 = require("./options/arrowToolOptions");
const genericTool_1 = require("./genericTool");
class ArrowTool extends genericTool_1.GenericTool {
    constructor(options) {
        super(arrowToolOptions_1.ArrowToolOptions, options);
    }
    onMouseDown() {
        super.onMouseDown();
        this.annotator.canvas.selection = false;
        this.annotation = new fabric_with_gestures_1.fabric.Group();
        this.line = new fabric_with_gestures_1.fabric.Line([
            this.initialPosition.x,
            this.initialPosition.y,
            this.initialPosition.x,
            this.initialPosition.y
        ], {
            stroke: this.options.color,
            strokeWidth: this.options.width,
            strokeUniform: true
        });
        this.triangle = new fabric_with_gestures_1.fabric.Triangle({
            stroke: this.options.color,
            fill: this.options.color,
            strokeWidth: this.options.width,
            strokeUniform: true,
            height: this.options.pointerHeight,
            width: this.options.pointerWidth,
            top: this.initialPosition.x,
            left: this.initialPosition.y,
            centeredRotation: true,
            originX: 'center',
            originY: 'center',
            lockScalingX: true,
            lockScalingY: true,
            lockSkewingX: true,
            lockSkewingY: true
        });
        this.annotator.canvas.add(this.line);
        this.annotator.canvas.add(this.triangle);
    }
    onMouseMove() {
        const pointer = this.annotator.canvas.getPointer(null);
        this.line.set('x2', pointer.x);
        this.line.set('y2', pointer.y);
        this.line.dirty = true;
        var xDiff = pointer.x - this.line.x1;
        var yDiff = pointer.y - this.line.y1;
        var angle = (Math.atan2(yDiff, xDiff) / Math.PI * 180);
        angle = (angle) % 360 + 90;
        this.triangle.top = pointer.y + (this.line.strokeWidth / 2);
        this.triangle.left = pointer.x + (this.line.strokeWidth / 2);
        this.triangle.rotate(angle);
        this.triangle.dirty;
    }
    onMouseUp() {
        var x1 = this.line.get('x1');
        var x2 = this.line.get('x2');
        var y1 = this.line.get('y1');
        var y2 = this.line.get('y2');
        this.annotator.canvas.selection = true;
        if ((x1 == x2) && (y1 === y2)) {
            this.annotator.canvas.remove(this.line);
            this.annotator.canvas.remove(this.triangle);
            return false;
        }
        else {
            this.annotation.addWithUpdate(this.line);
            this.annotator.canvas.remove(this.line);
            this.annotation.addWithUpdate(this.triangle);
            this.annotator.canvas.remove(this.triangle);
            this.annotator.canvas.add(this.annotation);
            return true;
        }
    }
}
exports.ArrowTool = ArrowTool;
